import * as zod from 'zod';

import { CameraIntegration } from '@sb/integrations/types/cameraTypes';

import { Expression } from '../../types';
import { RegionOfInterest } from '../../vision/VisionInterface';

import { FileNamePart } from './captureConfig';

export default zod.object({
  camera: CameraIntegration.optional(),
  // Optional equipment ID for camera-bot-cpp mode (when set, camera field is ignored)
  cameraEquipmentId: zod.string().optional(),
  regionOfInterest: RegionOfInterest.optional(),
  saveEquipmentId: zod.string(),
  /** Names the file where set; see `namingExpression`. */
  saveFilepath: Expression.optional(),
  saveMetadata: zod.boolean().default(false),
  /** Parts after `capture_<timestamp>` in the file's name, without an expression. */
  fileName: zod.array(FileNamePart).optional(),
});
